module.exports = __webpack_public_path__ + "img/6.2316a2d3.png";